import { Home, Person } from '@mui/icons-material';
import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSystemActions } from 'stores';

const Footer = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const { t } = useTranslation();
	const { getImage } = useSystemActions();

	const currentPath = location.pathname;

	const [value, setValue] = useState(0);

	useEffect(() => {
		setValue(currentPath === '/' ? 0 : 1);
	});

	if (process.env.REACT_APP_HIDE_NAVBAR === 'true') return <></>;

	switch (location.pathname) {
		case '/':
		case '/User':
			break;
		default:
			return <></>;
	}

	return (
		<>
			<BottomNavigation
				sx={{
					backgroundColor: 'navBar.main',
					position: 'fixed',
					width: '100%',
					height: '48px',
					maxWidth: 'sm',
					bottom: 0,
					'& .Mui-selected': {
						color: (theme) =>
							`${theme.palette.navBar?.active} !important`,
					},
				}}
				value={value}
			>
				<BottomNavigationAction
					disableRipple
					sx={{ color: 'navBar.inactive' }}
					icon={<Home />}
					onClick={() => {
						navigate('/', { replace: true });
					}}
				/>
				<BottomNavigationAction
					disableRipple
					sx={{ color: 'navBar.inactive' }}
					icon={<Person />}
					onClick={() => {
						navigate('/User', { replace: true });
					}}
				/>
				{process.env.REACT_APP_ENABLE_NAVBAR_SCAN === 'true' && (
					<BottomNavigationAction
						disableRipple
						sx={{
							width: '80px',
							height: '80px',
							minWidth: '0',
							position: 'fixed',
							bottom: '8px',
							borderRadius: '100%',
							color: (theme) => theme.palette.navBar?.active,
							background: (theme) => theme.palette.primary.main,
						}}
						icon={<img src={getImage('navbar_scan.svg')}></img>}
						label={t('home.scan')}
						showLabel={true}
						onClick={() => {
							navigate('/Scan');
						}}
					/>
				)}
			</BottomNavigation>
		</>
	);
};

export default Footer;
